<template>
  <div class="node-config-content">
    <div>
      <span :config="config"> ✨ 并行网关无设置项 </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConcurrentNodeConfig',
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .node-config-content {
    span {
      color: #919398;
    }
  }
</style>
